var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-error_svg__clip0_3779_7645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12a12 12 0 1024 0 12 12 0 00-24 0z",
    fill: "#C01D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.286 6.641a1.286 1.286 0 10-2.572 0v5.572a1.286 1.286 0 002.572 0V6.64zm-1.286 12a1.714 1.714 0 100-3.428 1.714 1.714 0 000 3.428z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-error_svg__clip0_3779_7645"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default new URL("/codebuild/output/src2367840440/src/src/assets/icons/icon-error.svg", import.meta.url).toString();
export { SvgIconError as ReactComponent };